import Box from "@mui/material/Box"
import Chip from "@mui/material/Chip"
import dynamic from "next/dynamic";
const SmallLoadingSpinner = dynamic(() => import('@components/Components/Spinners/SmallLoadingSpinner'));
/**
 * Custom Tag component based on MUI Chip.
 *
 * @component
 * @example
 * // Example usage of Tag component
 * <Tag label="Example" color="primary" onClick={() => console.log("Clicked!")} />
 *
 * @param {object} props - The properties for the Tag component.
 * @param {object} props.sx - Custom styles for the Chip component.
 * @param {string} [props.label] - The label for the tag.
 * @param {string} [props.type] - Gives it the light tag color specified.
 * @param {string} [props.type_hover] - Gives it the light tag color specified for hover. 
 * @param {string} [props.color] - The color of the tag (e.g., "primary", "secondary").
 * @param {function} [props.onClick] - Callback function for click event.
 */

const Tag = (props) => {
    const {
        sx = {},
        type = false,
        type_hover = false,
        loading = false,
        label = "",
        ...rest
    } = props;
    
    const styles = type ? {
        backgroundColor: `${type}.light`, 
        color: `${type}.main`, 
        borderColor: `${type}.main`,
        ...(type_hover ? {
            ':hover': {
                backgroundColor: `${type}.main`,
                color: `${type}.contrastText`
            }
        } : null)
    } : {};
    
    return (
        <Chip
            disabled={loading}
            sx={{
                borderRadius: '5px',
                ...styles,
                ...sx,
            }}
            label={
                <Box
                    sx={{
                        minWidth: loading ? '75px' : 'auto'
                    }}
                >
                    {loading ? (
                        <SmallLoadingSpinner className={loading ? 'margin-auto d-flex' : ''}  styles={{height: '16px', width: '16px'}} />
                    ) : label}
                </Box>
            }
            {...rest}
        />
    )
}

export default Tag